module.exports = __webpack_public_path__ + "img/test01-1.fce73649.jpg";